import * as React from "react";
const SvgEmail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 0h20v20H0z" />
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="m13.75 7.75-2.347 1.875c-.773.615-2.04.615-2.813 0L6.25 7.75m7.5 8.625h-7.5c-2.25 0-3.75-1.125-3.75-3.75v-5.25c0-2.625 1.5-3.75 3.75-3.75h7.5c2.25 0 3.75 1.125 3.75 3.75v5.25c0 2.625-1.5 3.75-3.75 3.75"
    />
  </svg>
);
export default SvgEmail;
